// extracted by mini-css-extract-plugin
export var card = "_lo-5";
export var cardSelected = "_lo-4";
export var image = "_lo-3";
export var modal = "_lo-0";
export var modalContent = "_lo-1";
export var table = "_lo-2";